export default __webpack_public_path__ + "static/media/55_1_3.0b84a5ef.png";